import { FLAGS } from '@iheartjane/feature-flags';

import { useRootLoaderData } from './useRootLoaderData';

export function useShowInlineWizardCta(): boolean {
  const { featureFlags } = useRootLoaderData();
  return Boolean(featureFlags[FLAGS.obWizardBannerEnabled]);
}
